import { render, staticRenderFns } from "./ImportarController.vue?vue&type=template&id=e770885a&"
import script from "./ImportarController.vue?vue&type=script&lang=js&"
export * from "./ImportarController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports